import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * 旧パスから新パスへの自動リダイレクトを行うフック
 * SPAでページ遷移が発生せず、nginxリダイレクトが効かない場合の対策
 */
export const usePathRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathMap: Record<string, string> = {
      '/login': '/login-v2',
      '/price-show': '/price-show-v2',
      '/quotations': '/quotations-v2',
      '/medicines': '/medicines-v2',
      '/draft-quotation': '/draft-quotation-v2',
    };

    const currentPath = location.pathname;

    // 完全一致でリダイレクト
    if (pathMap[currentPath]) {
      navigate(pathMap[currentPath], { replace: true });
      return;
    }

    // /quotations/:id パターンのリダイレクト
    const quotationDetailMatch = currentPath.match(/^\/quotations\/(.+)$/);
    if (quotationDetailMatch) {
      navigate(`/quotations-v2/${quotationDetailMatch[1]}`, { replace: true });
      return;
    }
  }, [location.pathname, navigate]);
};
